const styles = {
    container: {
        maxWidth: '100%',
        mt: '24px',
    },
    title: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '32px',
        lineHeight: '48px',
        color: '#090C39',
        textTransform: 'capitalize',
    },
    divider: {
        color: '#E0E4ED',
        marginTop: '32px',
        marginBottom: '32px',
    },
    table: {
        padding: '24px',
        borderRadius: '16px',
        mt: 3,
        boxShadow: '0px 30px 30px rgba(151, 172, 191, 0.08), 0px 0px 30px rgba(151, 172, 191, 0.12)',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
    },
    content: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        gap: '10px',
        alignItems: 'center',
    },
    selectedFilters: {
        gap: '20px',
    },
    chip: {
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'SILKA_REGULAR',
        lineHeight: '16px',
        height: '24px',
        backgroundColor: 'rgba(61, 135, 191, 0.1)',
        borderWidth: 0,
    },
    chipDelete: {
        mt: '-10px !important',
    },
    suggestedButton: {
        display: 'flex',
        width: '251px',
        height: '48px',
        borderRadius: '16px',
        alignItems: 'center',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
    },
    suncButton: {
        display: 'flex',
        width: '251px',
        height: '48px',
        borderRadius: '16px',
        alignItems: 'center',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        marginLeft: 'auto',
    },
    suggestedResource: {
        width: '200px',
        height: '27px',
        fontFamily: 'Silka_Regular',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
        color: '#27344E',
        marginBottom: '17px',
    },
};
export default styles;
